<template>
<v-card width="300px" class="rounded-card">
    <v-card-title class="teal mb-2 py-1" v-bind:class="{'grey': tmr.inactive }">
        {{tmr.code}} - {{tmr.name}}
        <v-tooltip top>
            <template v-slot:activator="{on}">
            <v-icon right class="ms-5" color="orange lighten-1" v-on="on"
                v-if="tmr.premixkey != null && tmr.premixkey != ''">mdi-grain
            </v-icon>
            </template>
            <span>{{$t('Premix')}}</span>
        </v-tooltip>
    </v-card-title>
    <v-layout>
      <v-flex xs9>
        <v-card-text class="py-1">
            <span>{{$t('Version')}}: </span>
            <span class="font-weight-medium">{{tmr.version}}</span>
        </v-card-text>
        <v-card-text class="py-1">
            <span>{{$t('Dose Weight')}}: </span>
            <span class="font-weight-medium">{{dose | kgString}}</span>
        </v-card-text>
      </v-flex>
      <v-flex xs3>
        <v-btn icon @click.stop="edit()">
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-icon color="primary" v-on="on">mdi-square-edit-outline</v-icon>
            </template>
            <span>{{'Edit TMR' + " " + tmr.code}}</span>
          </v-tooltip>
        </v-btn>
      </v-flex>
    </v-layout>
    <AddEditTMR v-bind:value.sync="showDialog" v-bind:tmrId="tmrId" v-on:close="close" />
</v-card>
</template>

<script>
import AddEditTMR from "../components/AddEditTMR";
export default {
  name: "TMRPanel",
  props: ["tmrId"],
  data()  {
    return {
      showDialog: false,
    }
  },
  computed: {
    tmr() {
      return this.$store.getters.getTMR(this.tmrId);
    },
    dose() {
      return this.$store.getters.getTMRDoseWeight(this.tmr.feeds);
    }
  },
  methods: {
    edit() {
      this.showDialog=true;
    },
    close() {
      this.showDialog=false;
    }
  },
  components: {
     AddEditTMR,
  }
}
</script>

<style>
  .rounded-card {
    border-radius:8px;
  }
</style>
